import { combineReducers } from '@reduxjs/toolkit';
import { sidePanelSlice } from './sidePanelsSlice';
import pollsPanelReducer from './polls/pollsPanelSlice';

const generalReducer = sidePanelSlice.reducer;

export default combineReducers({
  general: generalReducer,
  polls: pollsPanelReducer,
});

export * from './sidePanelsSlice';
